<script setup lang="ts">
import { SaleSteppedPrice } from '@lib/shared';

import type { AuctionItemEntity } from '~/apiClient';

// PROPS
interface Props {
    auction: AuctionItemEntity;
}
const { auction } = defineProps<Props>();

// COMPOSABLES
const { tn, tt } = useTypedI18n();
const { data: authData } = useAuthUtils();

// DATA
const isSeller = computed(() => authData.value?.user?.companyId === auction.sellerCompanyId);
const shouldShow = computed(() => !isSeller.value);
const steppedPrice = computed(() => new SaleSteppedPrice(auction.minBidStepAmount, auction.minBidStepAmountThreshold, auction.maxBidStepAmount));
const min = computed(() => steppedPrice.value.getStepRoundedReservePrice(auction.computedMinMarketPrice));
const max = computed(() => steppedPrice.value.getStepRoundedReservePrice(auction.computedMaxMarketPrice));
</script>

<template>
    <div v-if="shouldShow" class="text-muted text-sm">
        <span class="inline-flex items-center gap-1">
            {{ tt('auction.estimatedMarketValue.label') }}
            <BaseTooltip :text="tt('auction.estimatedMarketValue.tooltip')">
                <UIcon name="lucide:info" class="size-4 shrink-0" />
            </BaseTooltip>
        </span>
        <p class="text-base font-semibold">{{ tn(min, 'currency') }} – {{ tn(max, 'currency') }}</p>
    </div>
</template>
